import dayjs from 'dayjs'
import { calcDate, composeCountDownText } from '@/common/js/countdown'
import './index.styl'

export default {
  props: {
    startTimeStamp: {
      type: Number
    },
    endTimeStamp: {
      type: Number
    }
  },
  data() {
    return {
      countDown: [0, 0, 0, 0],
      countDownText: ''
    }
  },
  methods: {
    getLeftTimeText(startTimeStamp, endTimeStamp) {
      if (!(startTimeStamp || endTimeStamp)) {
        return (this.countDownText = '')
      }
      if (dayjs.unix(startTimeStamp).isAfter(dayjs())) {
        const currentTime = dayjs().unix() // 活动正式开始时刷新页面

        if ((startTimeStamp - currentTime) <= 1) {
          return window.location.replace(window.location.href)
        }

        this.countDown = calcDate(startTimeStamp)
        this.countDownText = `距活动开始剩余：${composeCountDownText(this.countDown)}`
        return
      }

      if (dayjs.unix(endTimeStamp).isAfter(dayjs())) {
        const currentTime = dayjs().unix() // 当可以报名时刷新页面

        if ((endTimeStamp - currentTime) <= 1) {
          return window.location.replace(window.location.href)
        }

        this.countDown = calcDate(endTimeStamp)
        this.countDownText = `距活动截止剩余：${composeCountDownText(this.countDown)}`
        return
      }

      this.countDown = [0, 0, 0, 0]
      this.countDownText = `活动已结束`
    }
  },
  mounted() {
    const timeoutCallback = () => {
      this.getLeftTimeText(this.startTimeStamp, this.endTimeStamp)

      if (this.timer !== null) {
        this.timer = setTimeout(timeoutCallback, 1000)
      }
    }

    timeoutCallback()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
    this.timer = null
  },
  render(h, context) {
    return (
      this.countDownText && (
        <div class="countdown-component">
          <span>{this.countDownText}</span>
        </div>
      )
    )
  }
}